import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import AnalysisFlowchart from 'analysis-tool/flowchart/AnalysisFlowchart';
import {AnalysisFlowchartMode} from 'analysis-tool/flowchart/AnalysisFlowchartContext';
import {AnalysisTemplateGraphQL} from 'analysis-tool/templates/AnalysisTemplateTypes';

interface AnalysisFlowchartViewProps {
  analysisTemplate: AnalysisTemplateGraphQL;
}

/**
 * A flowchart representation of an analysisTemplate, as rendered full-screen in the template collections page.
 *
 * This view is read-only. When `ENABLE_ANALYSIS_TOOL_EDITABLE_TEMPLATES` is enabled, analysis templates are
 * edited in `<AnalysisFlowchartView>`.
 */
export default function AnalysisTemplateFlowchartView({
  analysisTemplate,
}: AnalysisFlowchartViewProps): JSX.Element {
  return (
    <div className={css(styles.wrapper)}>
      <div className={css(styles.flowchart)}>
        <AnalysisFlowchart
          analysis={analysisTemplate}
          mode={AnalysisFlowchartMode.STATIC}
          availableActions={[]}
        />
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  flowchart: {
    height: '100%',
    width: '100%',
  },
});
